export default {
  "sideMenu.cinemaWebsite": "ウェブサイト",
  "sideMenu.cinemaWebsite.news": "ニュース",
  "sideMenu.cinemaWebsite.custom": "カスタムページ",
  "sideMenu.cinemaWebsite.priceTable": "料金表",
  "sideMenu.cinemaWebsite.admissionInfo": "入場案内",
  "sideMenu.cinemaWebsite.notice": "注意事項",
  "sideMenu.cinemaWebsite.commonProblems": "よくあるご質問",
  "sideMenu.cinemaWebsite.rentalSpace":"カスタム欄（劇場案内）",
  "sideMenu.cinemaWebsite.privacyPolicy": "個人情報の扱いについて",
  "sideMenu.cinemaWebsite.serviceTerms": "利用規約",
  "sideMenu.cinemaWebsite.serviceTermsRemark": "備考",
  "sideMenu.cinemaWebsite.websiteSetting": "サイトのオプション",

  "cinemaWebsite.websiteGuideSetting.remark": "備考",
  "sideMenu.cinemaWebsite.colorStyleSetting": "カラースタイル",
  "sideMenu.cinemaWebsite.companyInfo": "会社概要",
  // News
  "sideMenu.cinemaWebsite.news.title": "ニュース一覧",
  "sideMenu.cinemaWebsite.news.category.all": "全て",
  "sideMenu.cinemaWebsite.news.category.notice": "お知らせ",
  "sideMenu.cinemaWebsite.news.category.importantNotice": "重要なお知らせ",
  "sideMenu.cinemaWebsite.news.category.activity": "イベント",
  "sideMenu.cinemaWebsite.news.category.send": "配信",
  "sideMenu.cinemaWebsite.news.category.campaign": "キャンペーン",
  "cinemaWebsite.news.table.header.publishYear": "公開日",
  "cinemaWebsite.news.table.header.category": "カテゴリ",
  "cinemaWebsite.news.table.header.title": "タイトル",
  "cinemaWebsite.news.table.header.subTitle": "サブタイトル",
  "cinemaWebsite.news.table.header.hpPublish": "HP公開",
  "cinemaWebsite.news.table.header.focusNews": "トップ記事設定",
  "cinemaWebsite.news.table.header.content": "コンテンツ",
  "cinemaWebsite.news.table.header.noHP": "非公開",
  "cinemaWebsite.news.table.header.showing": "公開中",
  "cinemaWebsite.news.table.header.show": "公開",
  "cinemaWebsite.news.table.header.scheduled": "予約公開",
  "cinemaWebsite.news.table.header.scheduledPublished": "予約公開（公開済）",
  "cinemaWebsite.news.table.header.scheduledPending": "予約公開（待機中）",

  "cinemaWebsite.news.detail.create/edit": "ニュース新規登録・編集",
  "cinemaWebsite.news.form.title.plsInput": "タイトルを入力してください",
  "cinemaWebsite.news.form.subTitle.plsInput": "サブタイトルを入力してください",
  "cinemaWebsite.news.form.submit": "作成する",
  "cinemaWebsite.news.form.category.required": "カテゴリが必要です",
  "cinemaWebsite.news.form.title.required": "タイトルが必要です",
  "cinemaWebsite.news.form.subTitle.required": "サブタイトルが必要です",
  "cinemaWebsite.news.form.hpPublish.required": "HP公開が必要です",
  "cinemaWebsite.news.form.focusNews.required": "トップ記事設定が必要です",
  "cinemaWebsite.news.form.publishTime.required": "公開日時が必要です",


  // Custom
  "sideMenu.cinemaWebsite.custom.title": "カスタムページ一覧",

  "cinemaWebsite.custom.plsInputContent": "タイトルや記事で検索",
  "cinemaWebsite.custom.create": "新規作成",
  "cinemaWebsite.custom.table.header.title": "タイトル",
  "cinemaWebsite.custom.table.header.sort": "順番(数字低い順で表示)",
  "cinemaWebsite.custom.table.header.content": "コンテンツ",

  "cinemaWebsite.custom.dialog.title": "新規登録・編集",
  "cinemaWebsite.custom.dialog.form.title": "タイトル",
  "cinemaWebsite.custom.dialog.form.title.plsInput": "タイトルを入力してください",
  "cinemaWebsite.custom.dialog.form.title.required": "タイトルが必要です",
  "cinemaWebsite.custom.dialog.form.sort": "順番(数字低い順で表示)",
  "cinemaWebsite.custom.dialog.form.sort.required": "順番(数字低い順で表示)が必要です",
  "cinemaWebsite.custom.dialog.form.content": "コンテンツ",
  // PriceTable
  "sideMenu.cinemaWebsite.priceTable.title": "料金表一覧",
  "cinemaWebsite.priceTable.plsInputName": "名前で検索",
  "cinemaWebsite.priceTable.table.header.name": "名前",
  "cinemaWebsite.custom.table.header.description": "説明",
  "cinemaWebsite.custom.table.header.price": "金額",

  "cinemaWebsite.priceTable.dialog.form.name.plsInput": "名前を入力してください",
  "cinemaWebsite.priceTable.dialog.form.description.plsInput": "説明を入力してください",
  "cinemaWebsite.priceTable.dialog.form.title.required": "名前が必要です",
  "cinemaWebsite.priceTable.dialog.form.description.required": "説明が必要です",
  "cinemaWebsite.priceTable.dialog.form.price.required": "金額が必要です",

  // WebsiteSetting
  "sideMenu.cinemaWebsite.websiteSetting.title": "ウェブサイトのオプション",
  "cinemaWebsite.websiteSetting.form.checkbox": "表示する",
  "cinemaWebsite.websiteSetting.formItem.newsTab": "ニュース",
  "cinemaWebsite.websiteSetting.formItem.movieComingTab": "近日上映",
  "cinemaWebsite.websiteSetting.formItem.movieShowingTab": "上映中",
  "cinemaWebsite.websiteSetting.formItem.movieHistoryTab": "上映履歴",
  "cinemaWebsite.websiteSetting.formItem.cinemaGuideTab": "劇場案内",
  "cinemaWebsite.websiteSetting.formItem.customisedTab": "カスタムページ1",
  "cinemaWebsite.websiteSetting.formItem.customisedTab2": "カスタムページ2",
  "cinemaWebsite.websiteSetting.formItem.accessTab": "アクセス",
  "cinemaWebsite.websiteSetting.formItem.seeMoreTab": "もっとみる",
  "cinemaWebsite.websiteSetting.formItem.websiteInformation": "サイト情報",

  // ColorStyleSetting
  "cinemaWebsite.colorStyleSetting.formItem.backgroundColor": "背景色",
  "cinemaWebsite.colorStyleSetting.formItem.btnTextColorSelected": "ボタンテキスト色（ 選択中 ）",
  "cinemaWebsite.colorStyleSetting.formItem.cardBackgroundColor": "カード背景色",
  "cinemaWebsite.colorStyleSetting.formItem.secondaryFontColor": "サブテキスト色",
  "cinemaWebsite.colorStyleSetting.formItem.mainColor": "テーマの色",
  "cinemaWebsite.colorStyleSetting.formItem.navBarFontColor": "メニューバーテキスト色",
  "cinemaWebsite.colorStyleSetting.formItem.labelBackgroundColor": "ラベル背景色",
  "cinemaWebsite.colorStyleSetting.formItem.navBarFontColorSelected": "メニューバーテキスト色（ 選択中 ）",
  "cinemaWebsite.colorStyleSetting.formItem.mainFontColor": "メインテキスト色",
  "cinemaWebsite.colorStyleSetting.formItem.navBarBackgroundColor": "メニューバー背景色",
  "cinemaWebsite.colorStyleSetting.formItem.btnFontColor": "ボタンテキスト色",

  // WebsiteInformation
  "cinemaWebsite.websiteInformation.formItem.favicon": "ファビコン",
  "cinemaWebsite.websiteInformation.formItem.metadata": "メタデータ",
  "cinemaWebsite.websiteInformation.formItem.favicon.placeholder": "ファビコン画像をアップロード",
  "cinemaWebsite.websiteInformation.formItem.metadata.placeholder": "メタデータを入力してください",

  // CompanyInfo
  "cinemaWebsite.companyInfo.formItem.companyName": "会社名",
  "cinemaWebsite.companyInfo.formItem.companyName.plsInput": "会社名を入力してください",
  "cinemaWebsite.companyInfo.formItem.establishedYear": "設立",
  "cinemaWebsite.companyInfo.formItem.establishedYear.plsInput": "設立を入力してください",
  "cinemaWebsite.companyInfo.formItem.business": "事業内容",
  "cinemaWebsite.companyInfo.formItem.business.plsInput": "事業内容を入力してください",
  "cinemaWebsite.companyInfo.formItem.capital": "資本金",
  "cinemaWebsite.companyInfo.formItem.capital.plsInput": "資本金を入力してください",
  "cinemaWebsite.companyInfo.formItem.representation": "代表者",
  "cinemaWebsite.companyInfo.formItem.representation.plsInput": "代表者を入力してください",
  "cinemaWebsite.companyInfo.formItem.phoneNumber": "電話番号",
  "cinemaWebsite.companyInfo.formItem.phoneNumber.plsInput": "電話番号を入力してください",

  "cinemaWebsite.companyInfo.formItem.self-definedColumnTitle": "カスタム欄タイトル",
  "cinemaWebsite.companyInfo.formItem.customColumnPortrait": "カスタム欄画像",
};
